import React, { useState, useEffect } from 'react';
import NavigationLinks from './NavigationLinks';
import useNavigationHandler from '../hooks/useNavigationHandler';
import LanguageSelector from './LanguageSelector';
import { useLanguage } from '../contexts/LanguageContext';

const Menu = () => {
    const { handleLinkClick } = useNavigationHandler({ triggerMenuClick: true });
    const { t } = useLanguage();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showLanguageSelector, setShowLanguageSelector] = useState(false);

    useEffect(() => {
        // Función para detectar si el menú está abierto
        const checkMenuState = () => {
            const hamburger = document.querySelector('.mxd-nav__hamburger');
            const isOpen = hamburger && hamburger.classList.contains('nav-open');
            setIsMenuOpen(isOpen);

            // Agregar delay para la aparición del selector de idioma
            if (isOpen) {
                setTimeout(() => {
                    setShowLanguageSelector(true);
                }, 300); // 300ms de delay
            } else {
                setShowLanguageSelector(false);
            }
        };

        // Verificar estado inicial
        checkMenuState();

        // Observar cambios en las clases del hamburger
        const observer = new MutationObserver(checkMenuState);
        const hamburger = document.querySelector('.mxd-nav__hamburger');

        if (hamburger) {
            observer.observe(hamburger, {
                attributes: true,
                attributeFilter: ['class']
            });
        }

        return () => observer.disconnect();
    }, []);

    return (
        <nav className="mxd-nav__wrap" data-lenis-prevent="">
            {/* Hamburger Start */}
            <div className="mxd-nav__contain loading__fade" style={{ opacity: 1 }}>
                <div className="nav-controls">
                    {showLanguageSelector && <LanguageSelector className="nav-language-selector visible" />}
                    <a href="#0" className="mxd-nav__hamburger">
                        <div className="hamburger__base"></div>
                        <div className="hamburger__line"></div>
                        <div className="hamburger__line"></div>
                    </a>
                </div>
            </div>
            {/* Hamburger End */}

            {/* Main Navigation Start */}
            <div className="mxd-menu__wrapper">
                <div className="mxd-menu__base" style={{ opacity: 0 }}></div>
                <div className="mxd-menu__contain">
                    <div className="mxd-menu__inner">
                        {/* left side */}
                        <div className="mxd-menu__left">
                            <p className="mxd-menu__caption menu-fade-in">
                                🏠 {t('menu.sell_property')}<br />{t('menu.no_cost')}
                            </p>
                            <div className="main-menu">
                                <nav className="main-menu__content">
                                    <ul id="main-menu" className="main-menu__accordion">
                                        <NavigationLinks onLinkClick={handleLinkClick} />
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        {/* right side */}
                        <div className="mxd-menu__right">
                            <div className="menu-promo">
                                <div className="menu-promo__content">
                                    <p className="menu-promo__caption menu-fade-in">
                                        💡 {t('menu.transparency')}<br />{t('menu.decisions')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Main Navigation End */}
        </nav>
    );
};

export default Menu;